import React, { useEffect, useState } from "react";
import "./SiteSummary.scss";
import Header from "../common/Header/Header";
import Tabs from "../common/Tabs/Tabs";
import LoaderOverlay from "../common/Loader/LoaderOverlay";
import Sidebar from "../common/Sidebar/Sidebar";
import { HeaderToFieldMap } from "./constants";

interface SiteSummaryProps {
  handleLogout: () => void;
}

const SiteSummary: React.FC<SiteSummaryProps> = ({ handleLogout }) => {
  const tabs = [
    { label: "List view", content: <div>Content for Tab 1 goes here</div>, badge: true, Uri: "" },
    { label: "Map view", content: <div>Content for Tab 3 goes here</div>, badge: false, Uri: "maps" },
  ];

  const [well, setWellData] = useState([]);
  const [mapsData, setMapsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tabsLoading, setTabsLoading] = useState(false);
  const [selectedNode, setSelectedNode] = useState<{ id: string; label: string } | null>(null);
  const [isPageLoad, setPageLoad] = useState(false)
  const [pageSize, setPageSize] = useState(10)
  const [pageSelected, setPageSelected] = useState<string>("10")
  const [intialHeaders, setIntitialHeaders] = useState([])
  const [intialColumns, setIntitialColumns] = useState([])
  const [dashboardData, setDashboardData] = useState<any[]>([]); //NEW

  // Function to get browser timezone
  function getBrowserTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  const queryParams = {
    timeZoneId: getBrowserTimeZone(),
    nodeId: selectedNode?.id === "#" || selectedNode?.id === undefined ? null : selectedNode?.id,
    customerId: null
  };

  const baseUrl = process.env.REACT_APP_SERVER_ENDPOINT;
  const apiUrl = `${baseUrl}/Wells/GetALLWells?${new URLSearchParams(queryParams).toString()}`;

  const dashboardApiUrl = `${baseUrl}/Wells/GetWellsDashboard?${new URLSearchParams(queryParams).toString()}`; //NEW

  const userPrefrenceApiUrl = `${baseUrl}/UserPreference/GetUserPreference`;

  const updateWellsCache = (wellsData: any[]) => {
  try {
    const mapped = (wellsData || []).map((w: any) => ({
      id: w.assetId,
      name: w.wellName,
      value: w.wellName,
      customerId: w.customerId
    }));

    const cachePayload = {
      ts: Date.now(),
      data: mapped
    };

    sessionStorage.setItem(
      "wellsCache",
      JSON.stringify(cachePayload)
    );

    // Notify all listeners
    window.dispatchEvent(
      new CustomEvent("wells-cache-updated", {
        detail: cachePayload
      })
    );
  } catch (e) {
    console.error("Failed to update wells cache", e);
  }
};
  // Load nodeId from localStorage on mount
  useEffect(() => {
    const storedNode = localStorage.getItem("selectedNode");
    if (storedNode) {
      setSelectedNode(JSON.parse(storedNode));
    }

  }, []);

  useEffect(() => {
    const isSessionPageLoad = sessionStorage.getItem("isPageReload");

    if (isSessionPageLoad === "true") {
      setPageLoad(true);
    } else if (isSessionPageLoad === "false") {
      setPageLoad(false);
    } else if (isSessionPageLoad === null) {
      // First-time login scenario (no session key exists)
      setPageLoad(true);
    }
  }, []);


  // Save selectedNode to localStorage
  useEffect(() => {
    if (selectedNode) {
      localStorage.setItem("selectedNode", JSON.stringify(selectedNode));
    }
  }, [selectedNode]);

  useEffect(() => {
    const selectedCustomers = JSON.parse(localStorage.getItem("selectedCustomers")) || [];
    const selectedCustomersLength = Array.isArray(selectedCustomers) ? selectedCustomers.length : 0;
    let data = {}

    if (isPageLoad && selectedCustomersLength === 0) {
      setLoading(true)
      const fetchData = async () => {
        setLoading(true);
        const headers = {
          Authorization: `Bearer ${localStorage.getItem("jwtAccessToken")}`,
          "Content-Type": "application/json",
        };
        try {
          // Fetch both wells data and dashboard data
          const [wellsResponse, dashboardResponse] = await Promise.all([
            fetch(apiUrl, { headers }),
            fetch(dashboardApiUrl, { headers })
          ]);

          if (wellsResponse.status === 401 || dashboardResponse.status === 401) {
            handleLogout();
          }
          if (!wellsResponse.ok || !dashboardResponse.ok) {
            throw new Error("Network response was not ok");
          }

          data = await wellsResponse.json();
          const dashboardData = await dashboardResponse.json();

          const storedItemsPerPage = localStorage.getItem("itemsPerPage");

          if (!storedItemsPerPage || storedItemsPerPage === null || storedItemsPerPage === "undefined") {

            const userPrefernceResponse = await fetch(userPrefrenceApiUrl, { headers })
            const userPrefernceData = await userPrefernceResponse.json();
            if (userPrefernceData?.status === 401) {
              handleLogout();
            }

            if (userPrefernceData?.userPreference?.itemsPerPage?.toString()?.toLocaleLowerCase() === "all") {
              setPageSize(data[0]?.wells?.length + 1)
            } else {
              setPageSize(parseInt(userPrefernceData?.userPreference?.itemsPerPage?.toString()))
            }
            setPageSelected(userPrefernceData?.userPreference?.itemsPerPage?.toString())
            localStorage.setItem("itemsPerPage", userPrefernceData?.userPreference?.itemsPerPage);
          }
          const wellsData = data[0]?.wells || [];

          setWellData(wellsData);

          updateWellsCache(wellsData);
          setMapsData(data[0]?.location || []); //optional chaining to handle undefined
          setDashboardData(dashboardData?.charts || []); // Set dashboard data
          setIntitialHeaders(data[0]?.columns)

          const filteredColumns = data[0]?.columns
            .map((header) => HeaderToFieldMap[header])

          setIntitialColumns(filteredColumns)
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }

  }, [isPageLoad]) //NEW

  useEffect(() => {
    const storeduserPref = localStorage.getItem("itemsPerPage");

    if (storeduserPref?.toString().toLocaleLowerCase() === "all") {
      setPageSize(well?.length + 1)
    } else {
      setPageSize(parseInt(storeduserPref))
    }
    setPageSelected(storeduserPref)
  }, [well?.length])

  // Clear local storage and reset selectedNode only on page refresh
  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("selectedNode");
      localStorage.removeItem("multiSelectSelectedValues");
      localStorage.removeItem("selectedCustomers")
      sessionStorage.setItem("isPageReload", "true"); // Mark the page as reloaded
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  useEffect(() => {
    if (!selectedNode) return;
    setTabsLoading(true);
    sessionStorage.setItem("isPageReload", "false"); // Reset flag after handling it
    const fetchData = async () => {
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("jwtAccessToken")}`,
        "Content-Type": "application/json",
      };
      try {
        // Fetch both wells data and dashboard data
        const [wellsResponse, dashboardResponse] = await Promise.all([
          fetch(apiUrl, { headers }),
          fetch(dashboardApiUrl, { headers })
        ]);

        if (wellsResponse.status === 401 || dashboardResponse.status === 401) {
          handleLogout();
        }
        if (!wellsResponse.ok || !dashboardResponse.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await wellsResponse.json();
        const dashboardData = await dashboardResponse.json();

        const storedItemsPerPage = localStorage.getItem("itemsPerPage");
        if (!storedItemsPerPage || storedItemsPerPage === null || storedItemsPerPage === "undefined") {

          const userPrefernceResponse = await fetch(userPrefrenceApiUrl, { headers })
          const userPrefernceData = await userPrefernceResponse.json();
          if (userPrefernceData?.status === 401) {
            handleLogout();
          }

          if (userPrefernceData?.userPreference?.itemsPerPage?.toString()?.toLocaleLowerCase() === "all") {
            setPageSize(data[0]?.wells?.length + 1)
          } else {
            setPageSize(parseInt(userPrefernceData?.userPreference?.itemsPerPage?.toString()))
          }
          setPageSelected(userPrefernceData?.userPreference?.itemsPerPage?.toString())
          localStorage.setItem("itemsPerPage", userPrefernceData?.userPreference?.itemsPerPage);
        }
        else {
          const storeduserPref = localStorage.getItem("itemsPerPage");
          if (storeduserPref.toLocaleLowerCase() === "all") {
            setPageSize(data[0]?.wells?.length + 1)
          } else {
            setPageSize(parseInt(storeduserPref))
          }
          setPageSelected(storeduserPref)
        }
        const wellsData = data[0]?.wells || [];

        setWellData(wellsData);
        updateWellsCache(wellsData);

        setMapsData(data[0]?.location || []);
        setDashboardData(dashboardData?.charts || []); // Set dashboard data
        setIntitialHeaders(data[0]?.columns)
        const filteredColumns = data[0]?.columns
          .map((header) => HeaderToFieldMap[header])

        setIntitialColumns(filteredColumns)
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setTabsLoading(false);
      }
    };

    fetchData();
  }, [selectedNode?.id]); //NEW

  if (loading) {
    return <LoaderOverlay />;
  }

  return (
    <div className="flex">
      <Sidebar
        setSelectedNode={(node) => {
          setSelectedNode(node);
        }}
        handleLogout={handleLogout}
      />
      <div className="flex-grow bg-darkcolor-800 content-wrapper pl-[2px] ml-[55px] 2xl:ml-[55px] overflow-hidden">
        <Header
          home="Unify"
          loginCustomerName={localStorage.getItem("jwtUserName")}
          handleLogout={handleLogout}
          selectedLabel={selectedNode?.label}
        />
        <hr className="w-full h-[1px] mx-auto my-0 bg-darkcolor-300 border-0 rounded md:my-0 dark:bg-darkcolor-300" />
        <div className="flex bg-darkcolor-800 text-white">
          {tabsLoading ? <LoaderOverlay /> : <Tabs tabs={tabs} tableData={well} intialHeaders={intialHeaders} intialColumns={intialColumns} setWellData={setWellData} mapsData={mapsData} setSelectedNode={setSelectedNode} handleLogout={handleLogout} pageSize={pageSize} setPageSize={setPageSize} pageSelected={pageSelected} setPageSelected={setPageSelected} dashboardData={dashboardData} />}
        </div>
        <div className="mb-[100px]" />
      </div>
    </div>
  );
};

export default SiteSummary;
